"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgCabinLuggage = function SvgCabinLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#17181A"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 17,
    height: 13,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9c0-2.21-2.239-4-5-4S7 6.79 7 9"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgCabinLuggage);
var _default = Memo;
exports["default"] = _default;